module.exports = __webpack_public_path__ + "img/footer_card.47d62aca.jpg";